export type SortDirection = 'asc' | 'desc' | '';

export enum SortDirectionOptions  {
  asc ='asc',
  desc = 'desc',
  undefined = '',
}

export interface ISortState {
  column: string;
  direction: SortDirection;
}

export class GenericSortState implements ISortState {
  column = 'id'; // Id by default
  direction: SortDirection = 'asc'; // asc by default;
}

export interface ISortView {
  sorting: GenericSortState;
  ngOnInit(): void;
  sort(column: string): void;
}
